const STATUS_LABELS = {
  REQUESTED: "예약대기",
  CONFIRMED: "예약확정",
  REJECTED: "거절됨",
  CANCELLED: "취소",
  COMPLETED: "이용완료",
  NO_SHOW: "노쇼",
};

export function reservationStatusLabel(status) {
  return STATUS_LABELS[status] || status;
}

export function isCancellable(status) {
  return status === "REQUESTED" || status === "CONFIRMED";
}
